<p>Dem Job zugeordnete Dokumente:</p>

<clr-datagrid [clrDgLoading]="loading" *transloco="let t; prefix: 'pages.project'">
  <clr-dg-column [clrDgField]="'description'">{{ t('fileDescription') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'fileName'">{{ t('fileName') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'document_type'">{{ t('documentType') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'fileType'">{{ t('fileType') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'time'">{{ t('uploadDate') }}</clr-dg-column>
  <clr-dg-column></clr-dg-column>

  <clr-dg-placeholder>Keine Dateien zu Job {{ jobId }} vorhanden!</clr-dg-placeholder>

  <clr-dg-row *clrDgItems="let filesA of jobsFiles" [clrDgItem]="filesA">
    <clr-dg-action-overflow>
      <button class="action-item" *ngIf="filesA.fileType === 'application/pdf'" (click)="showModal(filesA.id)">Show PDF</button>
      <button class="action-item" (click)="loadFile(filesA.id, filesA.fileName)">Download</button>
    </clr-dg-action-overflow>
    <clr-dg-cell>{{ filesA.description }}</clr-dg-cell>
    <clr-dg-cell>{{ filesA.fileName }}</clr-dg-cell>
    <clr-dg-cell>{{ t( 'docTypes' + '.' + filesA.document_type.toString() ) }}</clr-dg-cell>
    <clr-dg-cell>{{ filesA.fileType }}</clr-dg-cell>
    <clr-dg-cell>{{ filesA.time | date: "dd.MM.yyyy" }}</clr-dg-cell>
    <clr-dg-cell>
      <cds-icon shape="times-circle" class="is-solid" (click)="deleteFile(filesA.id, filesA.fileName)"></cds-icon>&nbsp;
    </clr-dg-cell>
  </clr-dg-row>
</clr-datagrid><br />
<button *ngIf="!showFileUpload" class="btn btn-primary btn-sm" (click)="showFileUploader()">Datei hochladen</button>
<br />
<div *ngIf="showFileUpload">
  <h3>Datei für diesen Job hinzufügen</h3>
  <app-upload [componentId]="'0'" [companyId]=0 [projectId]=projectId [jobId]=jobId [subId]=0 [docType]=40 (closeModalEvent)="closeModal($event)"></app-upload>
</div>

<ng-container *ngIf="showPdf">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>
